import { TextField, TextFieldProps } from "@mui/material";
import React from "react";
import { styled } from "@mui/system";
import { colors } from "../../theme/color";

export const CustomTextField: React.FC<TextFieldProps> = (props) => {
  return <StyledTextField {...(props as any)} />;
};

const StyledTextField = styled(TextField)`
  font-size: 12px;
  border: 1px solid ${colors.general.brightGray};
  border-radius: 18px;
  box-sizing: border-box;
  outline: none;
  box-shadow: none !important;
`;
